// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledError = styled('div')(
  () => css`
    .ui-errors {
      .ui-errors-lable {
        color: #b71c1c !important;
      }
      .ui-errors-more {
        color: #991919 !important;
        font-size: 0.75rem;
        margin-right: 15px;
        cursor: pointer;
        .icon {
          margin-right: 10px;
          display: inline-flex;
        }
      }
      .ui-errors-list {
        list-style: none;
        user-select: text;
        padding: 0;
        margin: 0;
        direction: rtl;
        margin-top: 15px;
        color: #991919;
        .ui-errors-list-title {
          font-weight: bold;
        }
      }
    }
  `
);
